export default "__VITE_ASSET__Bo7hpHXu__"